import axios from "axios";
import config from "@/router/globalConfig";

export default {
    //============= Post API ===============
    PayLater(_data_) {
        return axios.post(config.WEB_API_PATH + 'pg/v1/PayLater', _data_, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
        });
    },
    //======================================
    //============== Get API ===============
    PayNow(_data_) {
        return axios.get(config.WEB_API_PATH + 'pg/v1/PayNow', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    GetPaymentDetails(_data_) {
        return axios.get(config.WEB_API_PATH + 'pg/v1/GetPaymentDetails', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    TransRequest(_data_) {
        return axios.get(config.WEB_API_PATH + 'pg/v1/TransRequest', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    TransSuccess(_data_) {
        return axios.get(config.WEB_API_PATH + 'pg/v1/TransSuccess', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    GetInvoiceDetails(_data_) {
        return axios.get(config.WEB_API_PATH + 'pg/v1/GetInvoiceDetails', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    GetPaymentReceipt(_data_) {
        return axios.get(config.WEB_API_PATH + 'pg/v1/GetPaymentReceipt', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    GetListFailedTransactions(_data_) {
        return axios.get(config.WEB_API_PATH + 'pg/v1/GetListFailedTransactions', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    //======================================
}


// WEBPACK FOOTER //
// ./src/components/serviceJS/paymentJS.js